// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"33f8de9e","99":"aab083f3","213":"59332f70","279":"5741a960","407":"8edb285d","448":"85844bf5","521":"10b074ac","728":"e9574f14","744":"148e502d","835":"a5c7e9b9","898":"24260a55","948":"9b8ab4b2","951":"fe19a58b"}[chunkId] + ".chunk.js";
};